const normalizePathname = (pathname = '') =>
  (pathname === '/' && pathname) || pathname.replace(/\/+$/, '');

export const isHomepageRoute = (pathname = '') =>
  ['/', '/bonuses', '/registration', '/login', '/reset-password', '/tour', '/zero'].includes(
    normalizePathname(pathname)
  );

export const isGlobalOrEventPageRoute = (pathname = '') =>
  /^\/(?:zero\/)?events(?:\/.*)?$/.test(normalizePathname(pathname));

export const shouldShowPortfolioHelpPanel = (pathname = '') =>
  !isHomepageRoute(pathname) && !isGlobalOrEventPageRoute(pathname);
